var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle--container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:['toggle--button', _vm.on ? 'on' : 'off']},[_c('span',{staticClass:"toggle--circle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }